import 'css-chunk:src/app/containers/Home/ClientFeaturesView/ClientFeaturesView.scss';export default {
  "ClientFeaturesView": "_ClientFeaturesView_15r3y_1"
};